module.exports = true;


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-runtime/~/core-js/library/modules/_library.js
 ** module id = 51
 ** module chunks = 0
 **/